import { j as h } from "./jsx-runtime-3tyXYecC.mjs";
import { useState as L, useRef as D, useEffect as V, useMemo as O, Fragment as U } from "react";
import { f as a } from "./index-LyFokDcn.mjs";
import { m as G } from "./tss-DN0acMKN.mjs";
import { M as b, d as x } from "./constants-CnFYFetN.mjs";
import { m as J } from "./index-BGgjYpYz.mjs";
import { g as K } from "./get-aria-describedby-G1wcWKF2.mjs";
const Q = G()((c, u, f) => {
  const { constructs: l, palette: e, typography: n, mode: t, borderRadiuses: r } = c, { size: y, isDisabled: o, isView: d, isReady: $, firstLabelWidth: w, secondLabelWidth: k } = u, { label: g, handle: S } = f, i = {
    small: {
      toggle: "32px",
      handle: "26px",
      fontSize: "small",
      lineHeight: "small"
    },
    medium: {
      toggle: a.ifFeature("encore", "40px", "34px"),
      handle: a.ifFeature("encore", "34px", "28px"),
      fontSize: a.ifFeature("encore", "medium", "large"),
      lineHeight: a.ifFeature("encore", "medium", "biggie")
    },
    large: {
      toggle: "48px",
      handle: "42px",
      fontSize: a.ifFeature("encore", "large", "large"),
      lineHeight: a.ifFeature("encore", "large", "large")
    }
  }[y === "regular" ? "medium" : y || "medium"], R = "200ms", z = "cubic-bezier(0.25, 0.1, 0.25, 1)";
  let m = e.gray[700];
  o && (m = e.gray[500]), d && (m = e.gray[600]);
  let s = e.primary.main;
  return o && (s = e.gray[400]), d && (s = e.gray[600]), t === b.Dye && (s = x.main), {
    toggle: {
      boxSizing: "border-box",
      color: o || d ? e.gray[500] : "inherit",
      position: "relative",
      backgroundColor: e.common.white,
      border: `1px solid ${o || d ? e.gray[300] : e.gray[400]}`,
      boxShadow: o ? "none" : "0 1px 0 0 rgba(0, 0, 0, 0.05)",
      display: "inline-flex",
      height: i.toggle,
      minWidth: "64px",
      width: "auto",
      borderRadius: a.ifFeature("encore", r[200], "2px"),
      outline: t === b.Dye ? `1px solid ${x.main}` : void 0,
      padding: "0 3px",
      pointerEvents: o || d ? "none" : "auto",
      userSelect: "none",
      "&:active, &:focus-within": {
        boxShadow: a.ifFeature(
          "encore",
          `0 0 0 1px ${t === b.Dye ? x.main : l.surface.primary.medium},
					 0 0 0 4px ${t === b.Dye ? x.main : l.surface.primary.weak}
					`,
          `0 0 0 2px ${t === b.Dye ? x.main : e.primary.lightest}`
        ),
        outline: 0,
        borderColor: e.primary.lighter
      }
    },
    label: {
      boxSizing: "border-box",
      textAlign: "center",
      textTransform: "capitalize",
      fontFamily: n.fontFamily,
      color: e.gray[700],
      cursor: o ? "default" : "pointer",
      fontWeight: n.fontWeightRegular,
      fontSize: n[i.fontSize].fontSize,
      lineHeight: n[i.lineHeight].lineHeight,
      padding: "2px 10px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      whiteSpace: "nowrap",
      zIndex: 1,
      transition: $ ? `${R} ${z}` : "none",
      // Wait to apply transition until component is loaded
      "&:last-of-type": {
        color: m
      }
    },
    handle: {
      backgroundColor: s,
      borderRadius: a.ifFeature("encore", r[200], "2px"),
      height: i.handle,
      left: "3px",
      top: "2px",
      position: "absolute",
      transition: $ ? `${R} ${z}` : "none"
      // Wait to apply transition until component is loaded
    },
    input: {
      height: "1px",
      opacity: 0,
      position: "absolute",
      width: "1px",
      [`&:first-of-type:checked ~ .${g}:first-of-type`]: {
        color: e.common.white,
        textShadow: `0 0 0.01px ${e.common.white}`
        // Using Bold causes the toggles width to shift - Hacky workaround to prevent that from happening
      },
      [`&:last-of-type:checked ~ .${g}:last-of-type`]: {
        color: e.common.white,
        textShadow: `0 0 0.01px ${e.common.white}`
        // Using Bold causes the toggles width to shift - Hacky workaround to prevent that from happening
      },
      [`&:first-of-type:checked ~ .${S}`]: {
        left: "3px",
        width: `${w}px`
      },
      [`&:last-of-type:checked ~ .${S}`]: {
        left: `${w + 3}px`,
        width: `${k}px`
      }
    }
  };
}), X = () => {
  const [c, u] = L(0), [f, l] = L(0), [e, n] = L(!1), t = D(null), r = D(null);
  return V(() => {
    t.current && u(t.current.offsetWidth), r.current && l(r.current.offsetWidth), requestAnimationFrame(() => {
      n(!0);
    });
  }, []), {
    firstLabelRef: t,
    firstLabelWidth: c,
    isReady: e,
    secondLabelRef: r,
    secondLabelWidth: f
  };
}, ae = (c) => {
  const {
    ariaLabel: u,
    ariaDescribedby: f,
    biId: l,
    id: e,
    inputRef: n,
    isChecked: t,
    isDisabled: r = !1,
    isRequired: y,
    isView: o = !1,
    name: d,
    onBlur: $,
    onChange: w,
    size: k = "medium",
    status: g,
    errorMessage: S,
    warningMessage: W,
    value: i,
    ...R
  } = c, z = O(() => J(), []), m = d || "fab-textToggle", s = e || `fab-text-Toggle--${z}`, j = `${s}-status-message`, A = K(g === "error" && S || g === "warning" && W ? j : "", f), I = [R["data-fabric-component"], "TextToggle"].filter(Boolean).join(" "), { firstLabelWidth: M, secondLabelWidth: H, isReady: q, firstLabelRef: N, secondLabelRef: P } = X(), { classes: F } = Q({ firstLabelWidth: M, isDisabled: r, isReady: q, isView: o, secondLabelWidth: H, size: k });
  return typeof i > "u" ? (console.error('Toggle Type "text" Requires the "value" Property.'), null) : Array.isArray(i) ? Array.isArray(i) && i.length !== 2 ? (console.error('The "value" Property must contain 2 strings.'), null) : /* @__PURE__ */ h.jsxs("div", { className: F.toggle, "data-fabric-component": I, id: s, children: [
    i.map((p, C) => {
      const T = `${s}-${p}`;
      let v = !!t;
      C !== 0 && (v = !t);
      const B = C === 0 ? N : P;
      return /* @__PURE__ */ h.jsxs(U, { children: [
        /* @__PURE__ */ h.jsx(
          "input",
          {
            "aria-describedby": A,
            "aria-label": u,
            checked: t === !0 || t === !1 ? v : void 0,
            className: F.input,
            "data-bi-id": l && `${l}-${p}`,
            defaultChecked: t === void 0 ? v : void 0,
            disabled: r,
            id: T,
            name: `${m}[]`,
            onBlur: $,
            onChange: (E) => w(E, { value: p }),
            ref: n,
            required: y,
            type: "radio"
          }
        ),
        /* @__PURE__ */ h.jsx("label", { className: F.label, htmlFor: T, ref: B, children: p })
      ] }, `${p}`);
    }),
    /* @__PURE__ */ h.jsx("div", { className: F.handle })
  ] }) : (console.error('The "value" Property must be an Array.'), null);
};
export {
  ae as T
};
//# sourceMappingURL=index-BlBizyO0.mjs.map
